import { useState } from 'react'
import { Button } from '@cottage/design-system/internal-tooling/ui'

type DuplicateCaseDialogProps = {
  caseName: string
  onCancel: () => void
  onConfirm: (name: string) => void
  saving?: boolean
  error?: string | null
}

export default function DuplicateCaseDialog({
  caseName,
  onCancel,
  onConfirm,
  saving = false,
  error = null,
}: DuplicateCaseDialogProps) {
  const [name, setName] = useState(`${caseName} copy`)

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4"
      onClick={onCancel}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="duplicate-case-title"
        className="relative w-full max-w-md rounded-xl bg-white p-5 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 id="duplicate-case-title" className="text-sm font-semibold text-gray-900">
          Duplicate case
        </h3>
        {error ? <p className="mt-2 text-sm text-red-600">{error}</p> : null}
        <p className="mt-3 text-sm text-gray-600">
          Create a copy of <span className="font-medium text-gray-900">{caseName}</span>.
        </p>
        <label className="mt-4 block text-sm text-gray-700">
          Case name
          <input
            type="text"
            className="input mt-1 w-full"
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoFocus
          />
        </label>
        <div className="mt-5 flex justify-end gap-2">
          <Button variant="outline" size="md" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            variant="primary"
            size="md"
            disabled={!name.trim() || saving}
            onClick={() => onConfirm(name.trim())}
          >
            Duplicate
          </Button>
        </div>
      </div>
    </div>
  )
}
